import http from '../../assets/js/http.js' //封装axios

// 小仓库
const state = {
    commons: {}
};
const mutations = {
    GETCOMMONS(state, data) {
        state.commons = data;
    },
};

const actions = {
    // 向服务器获取数据
    getCommons({
        commit
    }) {
        const dictArr = "baseImg,imgUrl,MediaUrl,uploadUrl";
        let parData = {
            parameterList: dictArr,
        };
        http.From("/parameter/getParameterInfo", parData).then((res) => {
            if (res.code == "0") {
                commit("GETCOMMONS", res.data);
                //存储字典信息
                sessionStorage.setItem("commons", JSON.stringify(res.data));
            } else {}
        });
    },

};
const getters = {
    baseImg(state) {
        return state.commons.baseImg || JSON.parse(sessionStorage.getItem("commons")).baseImg || [];
    },
    imgUrl(state) {
        return state.commons.imgUrl || JSON.parse(sessionStorage.getItem("commons")).imgUrl || [];
    },
    MediaUrl(state) {
        return state.commons.mediaUrl || JSON.parse(sessionStorage.getItem("commons")).mediaUrl || [];
    },
    uploadUrl(state) {
        return state.commons.uploadUrl || JSON.parse(sessionStorage.getItem("commons")).uploadUrl || [];
    },


};

export default {
    state,
    mutations,
    actions,
    getters
}